/* Content.tsx generated by @compiled/babel-plugin v0.5.2 */

import React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { gridSize } from '@atlaskit/theme/constants';
var _13 = "._1bsb1osq{width:100%}";
var _12 = "._p12fvyns{max-width:var(--_1w406pq)}";
var _11 = "._19bv70xm{padding-left:var(--_1xlms2h)}";
var _10 = "._n3tdidpf{padding-bottom:0}";
var _9 = "._u5f370xm{padding-right:var(--_1xlms2h)}";
var _8 = "._ca0qidpf{padding-top:0}";
var _7 = "._vchhusvi{box-sizing:border-box}";
var _6 = "._o5721q9c{white-space:nowrap}";
var _5 = "._1bto1l2s{text-overflow:ellipsis}";
var _4 = "._18m915vq{overflow-y:hidden}";
var _3 = "._1reo15vq{overflow-x:hidden}";
var _2 = "._s7n4jp4b{vertical-align:top}";
var _ = "._1e0c1o8l{display:inline-block}";
var HORIZONTAL_SPACING = "".concat(gridSize() / 2, "px");
export default (function (_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]), /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1o8l _s7n4jp4b _1reo15vq _18m915vq _1bto1l2s _o5721q9c _vchhusvi _ca0qidpf _u5f370xm _n3tdidpf _19bv70xm _p12fvyns _1bsb1osq"]),
    style: {
      "--_1xlms2h": ix(HORIZONTAL_SPACING),
      "--_1w406pq": ix(typeof maxWidth === 'number' ? "".concat(maxWidth, "px") : maxWidth)
    }
  }, children));
});